import React from 'react';
import type { IconProps } from '../types';

export const ArrowLeftBold = (props: IconProps) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>arrow-left</title>
    <g
      id="Icons"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Artboard"
        transform="translate(-268, -87)"
      >
        <g
          id="arrow-left"
          transform="translate(280, 99) scale(-1, 1) translate(-280, -99)translate(268, 87)"
        >
          <rect
            id="Rectangle"
            opacity="0.5"
            x="0"
            y="0"
            width="24"
            height="24"
          ></rect>
          <polygon
            id="Path"
            fill="currentColor"
            fillRule="nonzero"
            points="10.41 6 9 7.41 13.58 12 9 16.59 10.41 18 16.41 12"
          ></polygon>
        </g>
      </g>
    </g>
  </svg>
);

export default ArrowLeftBold;
